import { lead } from './lead';
import type { Brand } from './types';

export const jobiq: Brand = { ...lead, key: 'jobiq' };
